import styled from 'styled-components';

export const StepperDesktopStyled = styled.div`
  padding: 1.875em 3.625em;
`;
